<form [formGroup]="configForm">
  <div class="form__field">
    <label for="reloadDelay" class="input__label" i18n="@@d4_widget_config.reload_delay">Reload delay (minutes)</label>
    <p-inputnumber formControlName="reloadDelay" [showButtons]="true" [min]="1" [max]="60" />
  </div>
</form>
